import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <path fill="#1251A0" d="M74.206 52.161h320.737v191.675H74.206z" opacity=".2" />
      <path fill="#FAFAFA" d="M74.206 44.219h320.737v191.675H74.206z" />
      <path stroke="#50A1DA" strokeWidth="5" d="M84.975 76.967h299.202" />
      <path
        fill="#1251A0"
        fillRule="nonzero"
        d="M128.272 72.176v-8.34h7.854v8.34h-7.854zm3.39-1.741h1.076v-4.857h-1.075v4.857z"
      />
      <path fill="#15539F" d="M128.272 63.836h7.854v8.34h-7.854z" />
      <path
        fill="#1251A0"
        fillRule="nonzero"
        d="M120.187 72.176v-8.34h7.854v8.34h-7.854zm2.25-6.598v4.86h1.075V68.86h1.98v-1.143h-1.98v-.997h2.386v-1.142h-3.462z"
      />
      <path fill="#15539F" d="M120.187 63.836h7.854v8.34h-7.854z" />
      <path
        fill="#7BB934"
        fillRule="nonzero"
        d="M112.1 72.176v-8.34h7.853v8.34h-7.854zm3.387-1.741h1.076v-4.857h-1.076v4.857z"
      />
      <path fill="#7BB835" d="M112.1 63.836h7.853v8.34h-7.854z" />
      <path
        fill="#7BB934"
        fillRule="nonzero"
        d="M104.011 72.176v-8.34h7.854v8.34h-7.854zm1.863-6.598v4.86h1.837c1.261 0 2.286-1.088 2.286-2.429 0-1.34-1.025-2.428-2.286-2.428h-1.837v-.003zm3.05 2.428c0 .711-.544 1.286-1.21 1.286h-.761v-2.575h.76c.667.003 1.21.578 1.21 1.29z"
      />
      <path fill="#7BB835" d="M104.011 63.836h7.854v8.34h-7.854z" />
      <path
        fill="#51A2DA"
        fillRule="nonzero"
        d="M95.924 72.176v-8.34h7.853v8.34h-7.853zm3.916-6.653c-1.307 0-2.369 1.118-2.369 2.501 0 1.38 1.062 2.502 2.37 2.502 1.307 0 2.368-1.119 2.368-2.502 0-1.383-1.061-2.501-2.369-2.501zm0 3.866c-.715 0-1.296-.61-1.296-1.368 0-.757.581-1.368 1.296-1.368.715 0 1.296.611 1.296 1.368 0 .757-.58 1.368-1.296 1.368z"
      />
      <path fill="#53A2D9" d="M95.924 63.836h7.853v8.34h-7.853z" />
      <path
        fill="#51A2DA"
        fillRule="nonzero"
        d="M87.836 72.176v-8.34h7.85v8.34h-7.85zm4.978-6.598l-1.053 3.148-1.053-3.148h-1.353v4.86h1.076V68.16l.758 2.277h1.141l.758-2.277v2.277h1.076v-4.86h-1.35z"
      />
      <path
        fill="#53A2D9"
        d="M87.836 63.836h7.85v8.34h-7.85zM294.208 81.836h7.853v8.343h-7.853zM268.783 81.836h7.853v8.343h-7.853zM243.36 81.836h7.853v8.343h-7.853zM217.938 81.836h7.853v8.343h-7.853zM192.515 81.836h7.853v8.343h-7.853zM167.093 81.836h7.853v8.343h-7.853z"
      />
      <path fill="#E5E5E5" d="M168.592 140.927H300.56v15.055H168.592z" />
      <path stroke="#E5E5E5" strokeWidth="5" d="M168.592 111.495H300.56M168.592 123.94h86.41" />
      <path
        fill="#50A1DA"
        d="M181.18 152.255l-1.407-2.167-1.385 2.167-1.782-1.395 1.547-1.945-2.205-.474.658-2.32 2.157.873-.118-2.344h2.23l-.235 2.393 2.3-.921.61 2.319-2.252.474 1.642 1.945zM189.228 152.255l-1.407-2.167-1.385 2.167-1.783-1.395 1.548-1.945-2.206-.474.658-2.32 2.158.873-.118-2.344h2.229l-.235 2.393 2.3-.921.61 2.319-2.252.474 1.643 1.945zM197.276 152.255l-1.408-2.167-1.384 2.167-1.783-1.395 1.548-1.945-2.206-.474.658-2.32 2.158.873-.118-2.344h2.229l-.235 2.393 2.3-.921.61 2.319-2.252.474 1.643 1.945zM205.321 152.255l-1.408-2.167-1.384 2.167-1.783-1.395 1.548-1.945-2.206-.474.658-2.32 2.158.873-.118-2.344h2.229l-.235 2.393 2.3-.921.61 2.319-2.252.474 1.643 1.945z"
      />
      <path fill="#1251A0" d="M211.103 171.495h46.948v15.055h-46.948z" opacity=".2" />
      <path fill="#CCC" d="M211.094 167.848h46.948v15.055h-46.948z" />
      <path
        stroke="#FAFAFA"
        d="M231.794 174.474h5.547v5.894h-5.547zM236.391 172.219l-1.828-1.675-1.802 1.836M234.563 170.544v6.878"
      />
    </g>
  </Svg>
)
